import { Chip, SxProps, Theme } from "@mui/material"

const FX_HEDGED_CHIP_SX: SxProps<Theme> = { mx: 0.75 }

export default function FxHedgedChip() {
  return <Chip size="small" label="FX Hedged" sx={FX_HEDGED_CHIP_SX} />
}
